import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/common.translations';

const strings = new LocalizedStrings({
  en: {
    boxMessage: "Drag and drop some files, or click to upload",
    upload: {
      title: "Retry File Upload",
      goToMyDocuments: "Go to my documents",
      uploadSuccessful: "Upload successful!",
      errors: {
        mustProvideFile: "A file must be provided to upload.",
        unknown: "Unable to upload- please try again."
      }
    }
  }
});

export default withCommon<typeof strings>(strings);
